import React from 'react';
import { FiUpload } from 'react-icons/fi';

import { Modal } from '@components/Modal';
import { CsvImportDropzone } from '@components/CsvImportDropzone';
import {
  parseHolidayFileToRows,
  validateHolidayRows,
} from '@/utils/holidayImport';
import { SettingsPanelHeader } from './SettingsPanelHeader.component';

import styles from './HolidayImportModal.module.scss';

const HOLIDAY_CSV_COLUMNS = [
  { key: 'name', label: 'Holiday Name' },
  { key: 'date', label: 'Date' },
  { key: 'type', label: 'Type' },
  { key: 'description', label: 'Description' },
];

const HOLIDAY_CSV_TEMPLATE_ROWS = [
  ['Diwali', '2026-07-08', 'Public Holiday', ''],
  ['Christmas', '2026-12-25', 'Optional Holiday', ''],
];

export const HolidayImportModal = ({
  isVisible,
  onClose,
  onImport,
  existingDates = [],
}) => (
  <Modal isVisible={isVisible} onClose={onClose}>
    <div className={styles.importModal}>
      <SettingsPanelHeader
        icon={<FiUpload size={20} color="var(--indigo-600)" />}
        title="Import Holidays"
        description="Upload a CSV or Excel file using the same fields as Add Holiday: name, date, type and an optional description."
      />

      <CsvImportDropzone
        onImport={onImport}
        previewColumns={HOLIDAY_CSV_COLUMNS}
        templateFilename="holidays_template.csv"
        templateRows={HOLIDAY_CSV_TEMPLATE_ROWS}
        parseFile={parseHolidayFileToRows}
        validateRows={(rows) => validateHolidayRows(rows, existingDates)}
        itemNounSingular="holiday"
        itemNounPlural="holidays"
      />
    </div>
  </Modal>
);

HolidayImportModal.displayName = 'HolidayImportModal';
